export default __webpack_public_path__ + "static/media/tete47.7a5d88d8.png";